import { useEffect } from 'react';

//styles
import {
  FormWrapper,
  FormDescription,
  FormTitle,
  FormSubtitle,
  HubspotFormContainer,
  CustomContainer,
  DisclaimerWrapper,
} from './HubspotFormSimplified.styles';

//assets
import { DisclaimerText } from '@/vendor/HubspotFormIntegration';

// embed form
export const setHubspotFormIntegration = () => {
  const script = document.createElement('script');
  script.src = 'https://js.hsforms.net/forms/embed/developer/5041527.js';
  document.body.appendChild(script);
};

export const HubspotFormSimplifiedV4 = ({
  content,
  portalId,
  formId,
  target = 'integration-hubspot',
  region,
  disclaimer = false,
  theme = 'light',
}) => {
  useEffect(() => {
    setHubspotFormIntegration();
  }, []);

  return (
    <FormWrapper theme={theme} id={target}>
      <CustomContainer>
        <FormDescription theme={theme}>
          <FormTitle theme={theme}>{content.title}</FormTitle>
          <FormSubtitle theme={theme}>{content.subtitle}</FormSubtitle>
        </FormDescription>
        <HubspotFormContainer theme={theme}>
          <div
            className="hs-form-html"
            data-region={region}
            data-form-id={formId}
            data-portal-id={portalId}
          ></div>

          {disclaimer && (
            <DisclaimerWrapper>
              <DisclaimerText />
            </DisclaimerWrapper>
          )}
        </HubspotFormContainer>
      </CustomContainer>
    </FormWrapper>
  );
};
